// extracted by mini-css-extract-plugin
export var buttonWrapper = "liNSk";
export var day = "a2yv6";
export var disabled = "EMb3N";
export var enableMobileMode = "a2dCC";
export var endTime = "NXhEV";
export var icon = "oFnzK";
export var inheritFont = "ckn8f";
export var mobileLabel = "_tXTb";
export var nonWorkingDay = "LJICY";
export var row = "D14oz";
export var startTime = "CWL9J";
export var webLabel = "CIK00";